import React from 'react'

const NotaryStamp = ({ ...props }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        width: props.width,
        height: props.height,
        border: 'solid 5px #000',
        color: '#c0c0c0',
        fontSize: (props.width > 300) ? '2.5em' : '1.5em',
      }}
    >
      {props.watermark}
    </div>
  )
}

export default NotaryStamp
